/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function EditIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#232426'
        fillRule='evenodd'
        d='M16.836 3.336c-1.015 0-1.99.403-2.707 1.121l-10.5 10.5a1 1 0 0 0-.293.707v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l9.5-9.5 1-1a3.829 3.829 0 0 0-2.707-6.535m1 5.414.293-.293a1.829 1.829 0 0 0-2.586-2.586l-.293.293zm-4-1.172-8.5 8.5v2.586h2.586l8.5-8.5z'
        clipRule='evenodd'
      />
    </svg>
  )
}
